"use client";

import {JSX} from "react";

import {ImagePreview} from "./components/image-preview";

import "./styles/image-block.scss";

export interface ImageBlockProps {
    src: string;
    alt: string;
    showButton?: boolean;
    buttonText?: string;
    onButtonClick?: () => void;
    onImageClick?: () => void;
    className?: string;
    priority?: boolean;
    width?: number;
    height?: number;
}

/**
 * Image block component with preview and optional button
 */
export function ImageBlock({
    src,
    alt,
    showButton = false,
    buttonText = "View Photos & 3D Tour",
    onButtonClick,
    onImageClick,
    className = "",
    priority = false,
    width,
    height,
}: ImageBlockProps): JSX.Element {
    return (
        <div className={`image-block ${className}`}>
            <ImagePreview
                src={src}
                alt={alt}
                width={width}
                height={height}
                showButton={showButton}
                buttonText={buttonText}
                onButtonClick={onButtonClick}
                onImageClick={onImageClick}
                priority={priority}
            />
        </div>
    );
}
